import { Button } from "@/components/ui/button";
import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

const LandingCTAFinal = () => {
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0F] via-[#0F172A] to-[#0A0A0F]" />

      {/* Glows */}
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] bg-[#F59E0B]/8 rounded-full blur-[200px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          {/* Heading */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6 animate-fade-up">
            Reprenez le contrôle
            <span className="block bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] bg-clip-text text-transparent">
              de votre rentabilité
            </span>
          </h2>

          {/* Subtitle */}
          <p className="text-lg text-white/50 mb-10 max-w-xl mx-auto animate-fade-up [animation-delay:100ms]">
            Essayez B8ild gratuitement pendant 14 jours et voyez exactement où vous en êtes sur vos chantiers.
          </p>

          {/* CTA */}
          <div className="mb-10 animate-fade-up [animation-delay:200ms]">
            <Button
              size="lg"
              className="h-14 px-8 bg-[#F59E0B] hover:bg-[#FBBF24] text-[#0A0A0F] font-semibold text-lg gap-3 rounded-xl shadow-[0_0_0_1px_rgba(245,158,11,0.3),0_8px_40px_rgba(245,158,11,0.4)] hover:shadow-[0_0_0_1px_rgba(245,158,11,0.5),0_12px_50px_rgba(245,158,11,0.5)] hover:scale-[1.02] transition-all duration-300"
              asChild
            >
              <Link to="/auth?mode=signup">
                Commencer gratuitement
                <ArrowRight className="h-5 w-5" />
              </Link>
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 animate-fade-up [animation-delay:300ms]">
            {[
              "Installation en 5 min",
              "Sans carte bancaire",
              "Sans engagement",
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="h-5 w-5 rounded-full bg-[#10B981]/10 flex items-center justify-center">
                  <Check className="h-3 w-3 text-[#10B981]" />
                </div>
                <span className="text-sm text-white/50">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LandingCTAFinal;
